import type { RendererRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'renderer'
const rendererSiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const rendererRefs: RendererRefs = {
	scopedClassName: () => rendererSiteRefProvider(['scopedClassName']),
}

export { rendererRefs }
